import { render } from "./ImageCroppie.vue?vue&type=template&id=6ad655bf&ts=true"
import script from "./ImageCroppie.vue?vue&type=script&lang=ts"
export * from "./ImageCroppie.vue?vue&type=script&lang=ts"

import "./ImageCroppie.vue?vue&type=style&index=0&id=6ad655bf&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__